import React from 'react';

const AnalysisFlagBanner = ({ flags, title }) => {
    if (!flags || flags.length === 0) return null;

    return (
        <div className="red white-text floating-alert">
            <h4 className="center">{title}</h4>
            <ul>
                {flags.map((flag, index) => (
                    <li key={index}>{flag}</li>
                ))}
            </ul>
        </div>
    );
};

export default AnalysisFlagBanner;